import type { ColDef, ColGroupDef } from 'ag-grid-enterprise';

export const ASSET_DETAILS_PROPS = {
  ip_address: 'IP Address',
  asset_type: 'Type',
  asset_subtype: 'Subtype',
  operating_system: 'Operating System',
  domain: 'Domain',
  criticality: 'Criticality',
  health: 'Health',
  last_seen_at: 'Last Seen',
  security: 'Security',
  status: 'Status'
};

export const ASSET_PROVIDER_DETAILS_PROPS_CROWDSTRIKE = {
  machine_domain: 'Active Directory Domain',
  agent_version: 'Agent Version',
  device_id: 'Asset ID',
  bios_manufacturer: 'BIOS Manufacturer',
  bios_version: 'BIOS Version',
  build_number: 'Build Number',
  os_build: 'Build Version',
  product_type_desc: 'Device Type',
  chassis_type_desc: 'Form Factor',
  first_seen: 'First Seen',
  has_agent: 'Has Agent',
  reduced_functionality_mode: 'In RFM',
  kernel_version: 'Kernel Version',
  last_seen: 'Last Seen',
  mac_address: 'MAC Address',
  organizational_units: 'Organizational Units',
  os_version: 'OS Version',
  serial_number: 'Serial Number',
  site_name: 'Site Name'
};

export const ASSET_PROVIDER_DETAILS_PROPS_SENTINELONE = {
  agent_version: 'Agent Version',
  configurable_network_quarantine: 'Configurable Network Quarantine',
  external_ip: 'Console Visible IP',
  core_count: 'Core Count',
  cpu_type: 'CPU',
  domain: 'Domain',
  encrypted_applications: 'Disk Encryption',
  firewall_enabled: 'Firewall Enabled',
  full_disk_scan: 'Full Disk Scan',
  full_disk_scan_last_updated_at: 'Full Disk Scan Last Updated',
  group_ip: 'Group IP',
  has_agent: 'Has Agent',
  health_status: 'Health Status',
  installer_type: 'Installer Type',
  last_ip_to_mgmt: 'IP Address',
  last_scan_at: 'Last Active',
  last_reboot: 'Last Reboot',
  last_user: 'Last Logged In User',
  memory: 'Memory',
  model_name: 'Model',
  network_interfaces: 'Network Adapters',
  network_status: 'Network Status',
  ranger_version: 'Scanner Version',
  serial_number: 'Serial Number',
  site_name: 'Site',
  uuid: 'UUID'
};

export const ASSET_PROVIDER_DETAILS_PROPS_SIDECAR = {
  'logscale_details.architecture': 'Architecture',
  'logscale_details.id': 'LogScale ID',
  'logscale_details.ip': 'IP Addresses',
  'logscale_details.mac': 'MAC Addresses',
  'logscale_details.os.build': 'OS Build',
  'logscale_details.os.family': 'OS Family',
  'logscale_details.os.platform': 'OS Platform',
  'logscale_details.os.type': 'OS Type',
  'logscale_details.os.version': 'OS Version',
  'sidecar_details.ip': 'Console Visible IP',
  'sidecar_details.log_file_list': 'Log Files',
  'sidecar_details.metrics.cpu_idle': 'CPU Idle %',
  'sidecar_details.metrics.disks_75': 'Disks >75% Used',
  'sidecar_details.metrics.load_1': 'Load Average (1 min)',
  'sidecar_details.operating_system': 'Operating System',
  'sidecar_details.status.message': 'Status Message',
  'sidecar_details.tags': 'Console Tags',
  active: 'Active',
  agent_version: 'Agent Version',
  has_agent: 'Has Agent',
  host: 'Hostname',
  last_seen_logscale: 'LogScale Last Seen',
  last_seen_sidecar: 'Console Last Seen',
  managed: 'Managed',
  os_version: 'OS Version'
};

export const ASSET_PROVIDER_DETAILS_PROPS_VMPE = {
  active: 'Active',
  agent_version: 'Agent Version',
  created_in_shield: 'Created in Shield',
  enabled: 'Enabled',
  fully_qualified_domain_name: 'Fully Qualified Domain Name',
  has_agent: 'Has Agent',
  max_criticality: 'Max Criticality',
  password_required: 'Password Required',
  scanner_type: 'Scanner Type',
  shield_type: 'Shield Type',
  trusted_for_delegation: 'Trusted for Delegation'
};

export const NETWORK_ADAPTER_COLUMNS: (ColDef | ColGroupDef)[] = [
  { field: 'name', headerName: 'Name', width: 50, flex: 1 },
  { field: 'ip_address', headerName: 'IP Address', width: 150 },
  {
    field: 'mac_address',
    headerName: 'MAC Address',
    width: 200
  }
];

export const RUNNING_SERVICES_COLUMNS: (ColDef | ColGroupDef)[] = [
  { field: 'service_name', headerName: 'Name', width: 50, flex: 1 },
  { field: 'port', headerName: 'Port', width: 150 },
  { field: 'direction', headerName: 'Direction', width: 200 }
];

// delete everything below this line
//-----------------------------------------------------------------
export const TEST_RUNNING_SERVICES = [
  {
    name: 'RDP',
    port: '3389'
  },
  {
    name: 'HTTP',
    port: '80'
  },
  {
    name: 'DNS',
    port: '53'
  }
];

export const TEST_TAGS_AVALIABLE_OPTIONS = ['test1', 'test2', 'test3', 'test4'];
